import { BrokerId, FrontendLoadLocation } from '@trucksmarter/shared';
import { formatAppointmentTimestamp } from '@trucksmarter/shared_frontend';
import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import { EMPTY_VALUE_PLACEHOLDER } from '~/app/_ui/shared/text-placeholders';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';

interface Props {
  className?: string;
  location: FrontendLoadLocation;
  brokerId: BrokerId;
}

export default function AppointmentCell({ className, ...props }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <AppointmentCellContent {...props} />
    </DallasTableDataCell>
  );
}

export function AppointmentCellContent({
  location,
  brokerId,
}: Omit<Props, 'className'>) {
  const [start] = formatAppointmentTimestamp(location, brokerId).split(' - ');
  const [date, time] = start.split(' · ');

  return (
    <>
      <DallasText variant="captionL">
        {date || EMPTY_VALUE_PLACEHOLDER}
      </DallasText>
      <DallasText color="darkGray" variant="captionL" as="div">
        {time || EMPTY_VALUE_PLACEHOLDER}
      </DallasText>
    </>
  );
}
